"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const http_1 = require("@angular/http");
const translate_module_1 = require("./../../translate/src/translate.module");
const paging_component_1 = require("./paging/paging.component");
const datetime_component_1 = require("./datetime/datetime.component");
const resource_service_1 = require("./resources/resource.service");
const disablerOverlay_component_1 = require("./disablerOverlay/disablerOverlay.component");
const inView_directive_1 = require("./inView/inView.directive");
const modal_component_1 = require("./modal/modal.component");
const modalTest_component_1 = require("./modalTest/modalTest.component");
const panelExpander_directive_1 = require("./expandablePanel/panelExpanderDirective/panelExpander.directive");
const expandablePanel_component_1 = require("./expandablePanel/expandablePanelComponent/expandablePanel.component");
const pinButton_component_1 = require("./expandablePanel/pinButtonComponent/pinButton.component");
const standardPanelExpander_component_1 = require("./expandablePanel/standardPanelExpanderComponent/standardPanelExpander.component");
let CommonUiModule = class CommonUiModule {
    //Resource manager adds the translations to the translationservice
    constructor(_resourceManager) {
        this._resourceManager = _resourceManager;
    }
};
CommonUiModule = __decorate([
    core_1.NgModule({
        imports: [
            //Modules
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            http_1.HttpModule,
            translate_module_1.TranslateModule
        ],
        exports: [
            paging_component_1.PagingComponent,
            datetime_component_1.DateTimeComponent,
            disablerOverlay_component_1.DisablerOverlayComponent,
            inView_directive_1.InViewDirective,
            panelExpander_directive_1.PanelExpanderDirective,
            expandablePanel_component_1.ExpandablePanelComponent,
            modal_component_1.ModalComponent,
            modalTest_component_1.ModalTestComponent,
            pinButton_component_1.PinButtonComponent,
            standardPanelExpander_component_1.StandardPanelExpanderComponent
        ],
        declarations: [
            //Components
            paging_component_1.PagingComponent,
            datetime_component_1.DateTimeComponent,
            disablerOverlay_component_1.DisablerOverlayComponent,
            modal_component_1.ModalComponent,
            modalTest_component_1.ModalTestComponent,
            expandablePanel_component_1.ExpandablePanelComponent,
            pinButton_component_1.PinButtonComponent,
            standardPanelExpander_component_1.StandardPanelExpanderComponent,
            //Directives
            inView_directive_1.InViewDirective,
            panelExpander_directive_1.PanelExpanderDirective
        ],
        providers: [
            resource_service_1.CommonUiResourceManager, { provide: 'Window', useValue: window }
        ],
        bootstrap: []
    }),
    __metadata("design:paramtypes", [resource_service_1.CommonUiResourceManager])
], CommonUiModule);
exports.CommonUiModule = CommonUiModule;
